import { Button, Grid, Icon, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { useHistory } from "react-router-dom";
import "./Login.css";
import Header from "./Header";
import Footer from "../Footer";
import axios from "axios";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const submitLogin = (e) => {
    e.preventDefault();

    console.log("Username:", username);
    console.log("Password:", password);

    var data = `username=${username}&password=${password}&grant_type=password`;

    var config = {
      method: "post",
      url: "https://localhost:44300/Token",
      headers: {
        "Content-Type": "text/plain",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        console.log(response.data);
        localStorage.setItem("Token", response.data.access_token);
        history.push("/userinformation");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div className="login">
      <Header />
      <div className="login1">
        <hr
          style={{
            width: "95%",
            marginTop: "-30px",
            marginBottom: "30px",
            height: "2px",
            marginLeft: "2.5%",
          }}
        />
        <div className="max-width">
          <Typography className="topic">Welcome to LogIn page</Typography>
          <div className="content">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <div className="left">
                  <img src="/image/loginpic3.jpg" alt="" />
                </div>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <div className="right">
                  <AccountCircleIcon className="icon" />
                  <Typography className="text">Admin logIn</Typography>
                  <TextField
                    type="text"
                    label="Username"
                    variant="outlined"
                    size="small"
                    className="input"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <TextField
                    type="password"
                    label="Password"
                    variant="outlined"
                    size="small"
                    className="input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<ExitToAppIcon />}
                    style={{ width: "150px" }}
                    onClick={submitLogin}
                  >
                    LogIn
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Login;
